import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../mfe/MfeLoader";
import { getIntegrationsHostConfig } from "../../config/integrationsHostConfig";
import { useHostNavigate } from "../../hooks/useHostNavigate";

export const Route = createFileRoute("/integrations/")({
  component: IntegrationsPage,
});

function IntegrationsPage() {
  const onNavigate = useHostNavigate();
  return (
    <MfeLoader
      name="integrations"
      props={{ hostConfig: getIntegrationsHostConfig(onNavigate) }}
    />
  );
}
